<template>
    <svg width="46" height="40" viewBox="0 0 46 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="logoIcon_outside" fill-rule="evenodd" clip-rule="evenodd" d="M46 39.9594L38.2081 26.3978H11.0756L23.0139 5.69255L33.2825 23.5515H36.5662L23.0139 0L6.15003 29.2441H36.5662L41.0744 37.1132H4.92559L7.79189 32.1182H4.50817L0 39.9594H46Z" fill="#1C1363"/>
        <path class="logoIcon_inside" fill-rule="evenodd" clip-rule="evenodd" d="M23.0133 11.4131C18.6165 19.0311 14.2196 26.6211 9.85059 34.2391H13.1343L16.0006 29.2442H29.9982L32.8645 34.2391H36.1482C31.7792 26.6211 27.3823 19.0311 23.0133 11.4131ZM28.3563 26.3979H17.6425L23.0133 17.1056L28.3563 26.3979Z" fill="#006EFF"/>
    </svg>
</template>

<script>
export default {
  name: 'LogoIcon'
}
</script>

<style>
.logoIcon_outside{
    fill: var(--nav-menu-new-logo-iconOutside);
}
.logoIcon_inside{
    fill: var(--nav-menu-new-logo-iconInside);
}
</style>
